// @ts-check
/* eslint-env browser */

/** @typedef {import('../base-map/index.js').BaseMap} BaseMap */

export class ZoomExtents extends HTMLElement {
  connectedCallback () {
    const button = this.querySelector('button')
    const mapContainer = this.closest('map-container')

    if (!button || !mapContainer) return

    button.addEventListener('click', () => {
      /** @type {BaseMap | null} */
      const baseMap = mapContainer.querySelector('base-map')
      baseMap?.centerOnAllFeatures()
    })
  }
}

customElements.define('zoom-extents', ZoomExtents)
